import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const industryApi = createApi({
  reducerPath: "industry",
  tagTypes: ["Industries"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getIndustries: builder.query({
      query: () => "api/v2/industries",
      transformResponse: (response: any) => {
        return response.industries;
      }
    })
  })
});

export const { useGetIndustriesQuery } = industryApi;
